import * as React from 'react';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { NewbuildingMVKWidget } from '@cian/mvk-widget';
import { IGetNewbuildingPolygonsResponse } from '../../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';
import { loadScripts } from './helpers/loadScripts';
import { SectionTitle } from '../SectionTitle';
import * as styles from './newbuilding_mvk.css';

export interface INewbuildingMVKProps {
  MVKData?: IGetNewbuildingPolygonsResponse | null;
  httpApi: IHttpApi;
  mapApiKey: string;
  logger: ILogger;
  queryString: string;
  subdomain: string;
}

const MIN_WIDGET_HEIGHT = 480;

export class NewbuildingMVK extends React.Component<INewbuildingMVKProps> {
  public componentDidMount() {
    loadScripts();
  }

  public render() {
    const { MVKData, queryString, subdomain, mapApiKey, httpApi, logger } = this.props;

    if (!MVKData) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['header']}>
          <SectionTitle>Инфраструктура</SectionTitle>
        </div>
        <NewbuildingMVKWidget
          // Надо убирать api-models из mvk-widget CD-49347
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          MVKData={MVKData as any}
          httpApi={httpApi}
          logger={logger}
          containerStyles={{ height: MIN_WIDGET_HEIGHT }}
          queryString={queryString}
          subdomain={subdomain}
          mapApiKey={mapApiKey}
        />
      </div>
    );
  }
}
